import styles from './styles.module.scss';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Board } from '../../../../../components/Board';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions } from '../../../../../globalFunctions';
import { NavButton } from '../../../../../components/NavButton';
import Publication from './Publication';

export const LogicManagerPublicationRoute = () => {
  const [url, setURL] = useState<string>("");
  const [image, setImage] = useState<File | null>(null);
  const [ordem, setOrdem] = useState<number>(0);
  const [publications, setPublications] = useState<any[]>([]);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [editUrl, setEditUrl] = useState<string>("");
  const [editImage, setEditImage] = useState<File | null>(null);
  const [editOrdem, setEditOrdem] = useState<number>(0);
  const navigate = useNavigate();

  useEffect(() => {
    verifyRoutePermissions(
      ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
      navigate
    );
    fetchPublications();
  }, [navigate]);

  const fetchPublications = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/publication`
      );
      setPublications(data);
    } catch (error) {
      console.error('Erro ao buscar publicações:', error);
    }
  };

  const getBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (err) => reject(err);
    });
  };

  const resetForm = () => {
    setURL('');
    setImage(null);
    setOrdem(0);
    cancelEdit();
  };

  // Adicionar nova publicação
  const adicionarPublicacao = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('url', url);
    formData.append('ordem', ordem.toString());
    if (image) {
      const b64 = await getBase64(image);
      formData.append('image', b64);
    }
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/publication`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      resetForm();
      fetchPublications();
    } catch (error) {
      console.error('Erro ao adicionar publicação:', error);
    }
  };

  // Iniciar edição com preenchimento
  const editarPublicacao = (pub: any) => {
    setEditingId(pub.id);
    setEditUrl(pub.url);
    setEditOrdem(pub.ordem);
    setEditImage(null);
  };

  // Submeter edição
  const submitEdit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editingId === null) return;
    const formData = new FormData();
    formData.append('url', editUrl);
    formData.append('ordem', editOrdem.toString());
    if (editImage) {
        const b64 = await getBase64(editImage);
    }
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/publication/${editingId}`,
        {url: editUrl, image: editImage, ordem: editOrdem},
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      resetForm();
      fetchPublications();
    } catch (error) {
      console.error('Erro ao editar publicação:', error);
    }
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditUrl('');
    setEditOrdem(0);
    setEditImage(null);
  };

  const deletarPublicacao = async (id: number) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/publication/${id}`
      );
      setPublications(publications.filter((p) => p.id !== id));
    } catch (error) {
      console.error('Erro ao deletar publicação:', error);
    }
  };

  const goBackwards = () => navigate('/manager');

  return (
    <div className={styles.wrapper}>
      <Board wrapperClass={styles.board}>
        <div className={styles.container}>
          <h1 className={styles.titulo}>Publicações</h1>

          {/* Formulário de adicionar/editar */}
          <form
            onSubmit={editingId !== null ? submitEdit : adicionarPublicacao}
            className="form"
          >
            <input
              type="text"
              placeholder="Url"
              value={editingId !== null ? editUrl : url}
              onChange={(e) =>
                editingId !== null
                  ? setEditUrl(e.target.value)
                  : setURL(e.target.value)
              }
              required
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                editingId !== null
                  ? setEditImage(e.target.files?.[0] ?? null)
                  : setImage(e.target.files?.[0] ?? null)
              }
            />
            <input
              type="number"
              placeholder="Ordem"
              value={editingId !== null ? editOrdem : ordem}
              onChange={(e) =>
                editingId !== null
                  ? setEditOrdem(parseInt(e.target.value, 10))
                  : setOrdem(parseInt(e.target.value, 10))
              }
            />
            <button
              type="submit"
              style={{ backgroundColor: editingId !== null ? 'orange' : 'green', color: 'white' }}
            >
              {editingId !== null ? 'Salvar Edição' : 'Adicionar Publicação'}
            </button>
            {editingId !== null && (
              <button type="button" onClick={cancelEdit} className="btn btn-secondary">
                Cancelar
              </button>
            )}
          </form>

          {/* Lista de publicações */}
          <div className={styles.lista}>
            {publications.map((pub) => (

              <div key={pub.id} className={styles.item}>
                <Publication p={pub} deletarMembro={deletarPublicacao} />
                <div className={styles.actions}>
                  <button className={styles.actions} style={{backgroundColor: 'blue'}} onClick={() => editarPublicacao(pub)}>Editar</button>
                  <button className={styles.actions} style={{backgroundColor: 'red'}}onClick={() => deletarPublicacao(pub.id)}>Deletar</button>
                </div>
              </div>
              
            ))}
          </div>
        </div>
      </Board>

      <NavButton
        direction="left"
        style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
        onClick={goBackwards}
      />
    </div>
  );
};
